import { useForm } from '@mantine/form';

import { paymentTypeTypes } from '../types';

export type Fields = Omit<paymentTypeTypes.PaymentType, '_id'>;
type PaymentTypeFormProps = {
  initialValues: Fields;
};

export const usePaymentTypeForm = ({ initialValues }: PaymentTypeFormProps) => {
  return useForm({
    initialValues: {
      name: initialValues.name,
      key: initialValues.key,
      isPartial: initialValues.isPartial,
    },

    validate: {
      name: (value: string) => (!value ? 'Name is required' : null),
      key: (value: string) => (!value ? 'Key is required' : null),
      isPartial: (value: boolean) => (typeof value !== 'boolean' ? 'Required is partial' : null),
    },
  });
};
